module.exports = __webpack_public_path__ + "img/josip.5f86c88.webp";